// Translations for Samanext Technologies Landing Page

export const translations = {
  en: {
    // Navigation
    nav: {
      about: "About",
      vision: "Vision",
      portfolio: "Portfolio",
      contact: "Contact",
      viewPortfolio: "View Portfolio"
    },
    
    // Hero Section
    hero: {
      headline: "Architecting the Future of Global Trade & Finance.",
      subheadline: "Samanext Technologies is a California-based venture studio developing high-impact cognitive software solutions.",
      cta: "View Portfolio"
    },
    
    // About Section
    about: {
      label: "Who We Are",
      title: "Our Mission",
      description: "We bridge the gap between traditional industries and decentralized technologies. We incubate proprietary platforms that solve multi-billion dollar inefficiencies."
    },
    
    // Vision Section
    vision: {
      label: "Our Purpose",
      title: "Technology as the Great Equalizer",
      cards: [
        {
          id: 1,
          title: "The Bridge",
          description: "We believe technology is the key to equity. We build digital infrastructures that allow emerging economies to leapfrog traditional barriers, turning local industries into global powerhouses.",
          highlighted: false
        },
        {
          id: 2,
          title: "The Equation",
          description: "Automation creates stability. Advanced Tech + Local Talent = Economic Dignity. By bringing high-tech tools to under-served markets, we generate stronger social fabrics.",
          highlighted: false
        },
        {
          id: 3,
          title: "The Human Goal",
          description: "Keeping families together. Our deepest mission is to reduce forced migration through real economic opportunities. We dream of a future where no parent or child has to leave their family just to survive.",
          highlighted: true
        }
      ]
    },
    
    // Portfolio Section
    portfolio: {
      label: "Our Work",
      title: "Portfolio",
      projects: [
        {
          id: 1,
          name: "EQTOS",
          description: "The Cognitive Trade Operating System. An AI-powered platform directly connecting Latin American exporters with buyers in North America ($1.1T), Asia ($500B), and Europe ($300B).",
          label: "Flagship Project",
          link: "https://eqtos.tech",
          cta: "Visit Platform",
          isFlagship: true
        }
      ]
    },
    
    // Footer
    footer: {
      tagline: "Architecting the future of global trade and finance through innovative cognitive software solutions.",
      contact: "Contact",
      location: "Aliso Viejo, California, USA",
      email: "team@samanext.com",
      copyright: "© 2025 Samanext Technologies, LLC. All rights reserved."
    }
  },
  
  es: {
    // Navegación
    nav: {
      about: "Nosotros",
      vision: "Visión",
      portfolio: "Portafolio",
      contact: "Contacto",
      viewPortfolio: "Ver Portafolio"
    },
    
    // Sección Hero
    hero: {
      headline: "Arquitectando el Futuro del Comercio y las Finanzas Globales.",
      subheadline: "Samanext Technologies es un venture studio con sede en California que desarrolla soluciones de software cognitivo de alto impacto.",
      cta: "Ver Portafolio"
    },
    
    // Sección Acerca de
    about: {
      label: "Quiénes Somos",
      title: "Nuestra Misión",
      description: "Cerramos la brecha entre las industrias tradicionales y las tecnologías descentralizadas. Incubamos plataformas propietarias que resuelven ineficiencias billonarias."
    },
    
    // Sección Visión
    vision: {
      label: "Nuestro Propósito",
      title: "La Tecnología como el Gran Igualador",
      cards: [
        {
          id: 1,
          title: "El Puente",
          description: "Creemos que la tecnología es la clave de la equidad. Construimos infraestructuras digitales que permiten a las economías emergentes superar barreras históricas y competir globalmente.",
          highlighted: false
        },
        {
          id: 2,
          title: "La Ecuación",
          description: "La automatización crea estabilidad. Tecnología Avanzada + Talento Local = Dignidad Económica. Al llevar herramientas de punta a mercados desatendidos, fortalecemos el tejido social.",
          highlighted: false
        },
        {
          id: 3,
          title: "El Objetivo Humano",
          description: "Mantener a las familias unidas. Nuestra misión profunda es reducir la migración forzada mediante oportunidades económicas reales. Soñamos con un futuro donde ningún padre, madre o hijo tenga que dejar a su familia para sobrevivir.",
          highlighted: true
        }
      ]
    },
    
    // Sección Portafolio
    portfolio: {
      label: "Nuestro Trabajo",
      title: "Portafolio",
      projects: [
        {
          id: 1,
          name: "EQTOS",
          description: "El Sistema Operativo de Comercio Cognitivo. Una plataforma impulsada por IA que conecta directamente a exportadores de Latinoamérica con compradores de Norteamérica ($1.1T), Asia ($500B) y Europa ($300B).",
          label: "Proyecto Insignia",
          link: "https://eqtos.tech",
          cta: "Visitar Plataforma",
          isFlagship: true
        }
      ]
    },
    
    // Pie de Página
    footer: {
      tagline: "Arquitectando el futuro del comercio y las finanzas globales a través de soluciones innovadoras de software cognitivo.",
      contact: "Contacto",
      location: "Aliso Viejo, California, EE.UU.",
      email: "team@samanext.com",
      copyright: "© 2025 Samanext Technologies, LLC. Todos los derechos reservados."
    }
  }
};
